import Main from '@/layouts/Main.vue'
import Language from '../views/Language.vue';
import Register from '../views/Register.vue';
import RegisterThanks from '../views/RegisterThanks.vue';
import Verification from '../views/Verification.vue';
import ExpiredOrder from '../views/ExpiredOrder.vue';
import TermsAndConditions from '../views/TermsAndConditions.vue';

const routes = [
    {
        path: '/signup',
        component: Main,
        children: [
          {
            path: 'language',
            name: 'Language',
            component: Language,
            meta: {
                requiresAuth: false
            }
          },
        ],
    },
    {
      path: '/expiredorder',
      component: ExpiredOrder,
      children: []
    },
    {
      path: '/register',
      component: Main,
      children: [
        {
          path: '',
          name: 'register',
          component: Register,
          props: true,
          meta: {
            allowAnonymous: true
          }
        },
        {
          path: 'thanks',
          name: 'registerThanks',
          component: RegisterThanks,
          props: true,
          meta: {
            allowAnonymous: true
          }
        },
        {
          path: 'verification',
          name: 'Verification',
          component: Verification,
          meta: {
            allowAnonymous: true
          }
        },
        {
          path: 'terms',
          name: 'Terms',
          component: TermsAndConditions,
          meta: {
            allowAnonymous: true
          }
        }
      ]
    },
]

export default routes